import * as Yup from 'yup';
import IPaginator from './Paginator';



export const CUST_FILTER_SCHEMA = Yup.object({
  timeline: Yup.string().default('').defined(),
  activities: Yup.array().of(Yup.string()).default([]).defined(),
  customerRating: Yup.number().default(0).defined(),
  searchTerm: Yup.string().default('').defined(),
  sortBy: Yup.string().default('name').defined()
}).defined();

export type ICustomerFilter = Yup.InferType<typeof CUST_FILTER_SCHEMA>;

export const newCustFilterInstance = ():ICustomerFilter => {
  const obj =  CUST_FILTER_SCHEMA.cast();
  return Object.assign({},obj);
}

export interface ICustomerCollection {
  customers: Array<ICustomer>,
  paginator: IPaginator,
}


export const WHO_SCHEMA = Yup.object({
  createdOn: Yup.date().default(() => new Date()).transform(function (value, originalvalue) {
    //return this.isType(value) ? new Date(originalvalue._seconds): value;//TODO
    return new Date()
  }),
  owner: Yup.object({
    uid: Yup.string().default(() => {
      return 'anonymous'
    }),
    displayName: Yup.string().defined().default(() => {
      return 'anonymous'
    }),
    imageUrl: Yup.string().default(() => {
      return '';
    })
  }).defined()
}).defined();


export const CUSTOMER_SCHEMA = Yup.object({
  uid: Yup.string(),
  account: Yup.object({
    image: Yup.string().default(''),
    title: Yup.string().default(''),
    firstName: Yup.string().required('Please enter a first name.').default(''),
    lastName: Yup.string().required('Please enter a last name.').default(''),
    jobTitle: Yup.string().default('').defined(),
    departmentName: Yup.string().default('').defined(),
    company: Yup.string().default('').defined(),
    email: Yup.string().email().default('').required('Email is Required').defined(),
    phoneNumber: Yup.string().required('Phone Number is required').defined().default(''),
    additionalInfo: Yup.string().defined().default(''),
    status: Yup.string().required().default('ACTIVE')
  }).defined(),
  social: Yup.object({
    twitter: Yup.string().default('').defined(),
    facebook: Yup.string().default('').defined(),
    linkedin: Yup.string().default('').defined(),
    instagram: Yup.string().default('').defined(),
    youtube: Yup.string().default('').defined()
  }).defined(),
  personalInfo: Yup.object({
    dob: Yup.date().default(()=> new Date()).defined().transform(function (value, originalvalue) {
      //return this.isType(value) ? new Date(originalvalue._seconds): value;//TODO
      return new Date()
    }),
    website: Yup.string().url().default('').required('Website is required').defined()
  }).defined(),
  address: Yup.object({
    address1: Yup.string().default('').defined(),
    address2: Yup.string().default('').defined(),
    pincode: Yup.string().default('').defined(),
    city: Yup.string().default('').defined(),
    state: Yup.string().default('').defined(),
    country: Yup.string().default('').defined()
  }).defined(),
  lastActivity: Yup.number().default(0).defined(),
  who: WHO_SCHEMA
}).defined();

export const newCustInstance = ():ICustomer => {
  const obj =  CUSTOMER_SCHEMA.cast();
  return Object.assign({},obj);
}

export const isCustValid = async (cust:ICustomer) => {
  const valid:boolean =  await CUSTOMER_SCHEMA.isValid(cust);
  // This must be reverted. Returning for a flow check
  return true;
  // return valid;
}

export const validateCust = async (cust:ICustomer) => {
  let errors:any = {};
  try{
    const err:any = await CUSTOMER_SCHEMA.validate(cust, {abortEarly: false});
  }catch(err){
    errors= err.inner.reduce((obj:any, item:any) => {
      obj[item.path] = item.message;
      return obj;
    }, {});
  }
  return errors;
}

export const convertToCust = (doc:any):ICustomer => {
  return CUSTOMER_SCHEMA.cast(doc);
}

type ICustomer = Yup.InferType<typeof CUSTOMER_SCHEMA>;

export default ICustomer;